import { render } from "./Standort.vue?vue&type=template&id=1a3b54e3&scoped=true"
import script from "./Standort.vue?vue&type=script&lang=js"
export * from "./Standort.vue?vue&type=script&lang=js"

import "./Standort.vue?vue&type=style&index=0&id=1a3b54e3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3b54e3"]])

export default __exports__